import React from 'react';
import { View } from 'react-native';
import { useTheme } from '@ui-kitten/components';

import ThemeColor from '../../Theme/colors';

import ResponsiveText from '../ResponsiveText';

import styles from './styles';

type Props = {
  fill?: string;
  size?: number;
  textSize?: string;
  value: number;
  withX?: boolean;
};
function QuickCartQtyBadge({
  fill,
  size = 30,
  textSize = 'p2',
  value,
  withX = true,
}: Props) {
  const store_theme = useTheme();
  return (
    <View
      style={[
        styles.button,
        {
          backgroundColor:
            fill || store_theme['icon_color'] || ThemeColor.green,
        },
        { width: size, height: size, borderRadius: size / 2 },
      ]}
    >
      {withX ? (
        <ResponsiveText
          category={textSize}
          appearance="alternative"
          adjustsFontSizeToFit
        >
          {value}&times;
        </ResponsiveText>
      ) : (
        <ResponsiveText
          category={textSize}
          appearance="alternative"
          adjustsFontSizeToFit
        >
          {value}
        </ResponsiveText>
      )}
    </View>
  );
}

export default QuickCartQtyBadge;
